// Types
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ThumborStore, AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

interface ThumborizedImageAspectRatios {
  mobile: AspectRatioEnum;
  desktop: AspectRatioEnum;
}

/**
 * Function to get the thumborized image given an Hotel
 * @param {Hotel} hotel
 * @param {ThumborStore} thumbor
 */
export function getThumborizedImage(
  hotel: Hotel,
  thumbor: ThumborStore,
  context: ExtendedContextStore,
  aspectRatios: ThumborizedImageAspectRatios
) {
  const { hotelImageUrls } = hotel;
  const isMobile = !!(context && context.deviceInformation && context.deviceInformation.mobile);
  const width = isMobile ? 340 : 420;
  const height = isMobile ? 150 : 224;
  const hotelImageUrl =
    hotelImageUrls &&
    hotelImageUrls.y &&
    thumbor &&
    thumbor.safelyGenerateThumborizedImageUrl(
      hotelImageUrls.y,
      width,
      height,
      context,
      isMobile ? aspectRatios.mobile : aspectRatios.desktop,
      true,
      isMobile ? 60 : 100
    );

  return hotelImageUrl;
}
